import Avatar from 'antd/lib/avatar/avatar';
import * as React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles/appAvatarStyles';
import sdkOverlayImage from '../../assets/sdk-label-overlay.png';
import otaOverlayImage from '../../assets/ota-overlay.png';
import overlayAndroidImage from '../../assets/overlay-android.png';
import overlayAmazonImage from '../../assets/overlay-amazon.png';
import overlayHuaweiImage from '../../assets/overlay-huawei.png';
import overlaySamsungImage from '../../assets/overlay-samsung.png';
import overlayIosImage from '../../assets/overlay-ios.png';
import overlayTvOSImage from '../../assets/overlay-tvos.png';
import overlayVisionOSImage from '../../assets/overlay-visionos.png';
import overlayWearOSImage from '../../assets/overlay-wearos.png';
import overlayAndroidTVImage from '../../assets/overlay-android-tv.png';
import overlayBetaWorkdlowsImage from '../../assets/overlay-beta-workflows-badge.png';
import { AppPlatform, AppStoreType } from '../types';
interface AvatarLinkProps {
    square: boolean;
    isSelected: boolean;
    path: string;
    letter: string;
    imageUrl?: string;
    appPlatform?: AppPlatform;
    appStoreType?: AppStoreType;
    isDisabledTreatment: boolean;
    size?: number;
    hideOverlay?: boolean;
    shouldShowBetaOverlayOnWorkflowsBetaOrgs: boolean;
}

const AvatarLink: React.FC<AvatarLinkProps> = (props: AvatarLinkProps) => {
    const [overlayImage, overlayStyle] =
        props.appPlatform || props.shouldShowBetaOverlayOnWorkflowsBetaOrgs ?
            platformImageAndStyle(props.appPlatform, props.shouldShowBetaOverlayOnWorkflowsBetaOrgs, props.appStoreType)
        :   [null, null];
    let style = props.isSelected ? { ...styles.avatarSelected } : { ...styles.avatarUnselected };
    if (props.isDisabledTreatment) {
        style = props.isSelected ? { ...styles.avatarDisabledSelected } : { ...styles.avatarDisabledUnselected };
    }

    const avatarContent = (
        <div style={style}>
            <Avatar shape={props.square ? 'square' : 'circle'} size={props.size ?? 48} src={props.imageUrl}>
                {props.letter}
            </Avatar>
            {overlayImage && props.hideOverlay !== true && <img src={overlayImage} style={overlayStyle} />}
        </div>
    );

    return props.path ? <Link to={props.path}>{avatarContent}</Link> : avatarContent;
};

export default AvatarLink;

const platformImageAndStyle: (
    platform: AppPlatform,
    shouldShowBetaOverlayOnWorkflowsBetaOrgs: boolean,
    appStoreType?: AppStoreType,
) => [string, React.CSSProperties] = (platform, shouldShowBetaOverlayOnWorkflowsBetaOrgs, appStoreType) => {
    const pillStyle: React.CSSProperties = { width: 48, height: 48, position: 'absolute', top: 0, left: 16 };
    const cornerStyle: React.CSSProperties = {
        width: 30,
        height: 30,
        position: 'absolute',
        top: -12,
        right: 4,
    };

    if (shouldShowBetaOverlayOnWorkflowsBetaOrgs) {
        return [overlayBetaWorkdlowsImage, cornerStyle];
    }

    switch (platform) {
        case AppPlatform.WearOS:
            return [overlayWearOSImage, cornerStyle];
        case AppPlatform.Android:
            switch (appStoreType) {
                case AppStoreType.Amazon:
                    return [overlayAmazonImage, cornerStyle];
                case AppStoreType.Huawei:
                    return [overlayHuaweiImage, cornerStyle];
                case AppStoreType.Samsung:
                    return [overlaySamsungImage, cornerStyle];
                default:
                    return [overlayAndroidImage, cornerStyle];
            }
        case AppPlatform.TvOS:
            return [overlayTvOSImage, cornerStyle];
        case AppPlatform.VisionOS:
            return [overlayVisionOSImage, cornerStyle];
        case AppPlatform.Ios:
            return [overlayIosImage, cornerStyle];
        case AppPlatform.AndroidSDK:
        case AppPlatform.IosSDK:
            return [sdkOverlayImage, pillStyle];
        case AppPlatform.ReactNativeOTA:
            return [otaOverlayImage, pillStyle];
        case AppPlatform.AndroidTV:
            return [overlayAndroidTVImage, cornerStyle];
    }
};
